'use client'

import { memo } from 'react'
import { motion, useReducedMotion, useScroll, useTransform } from 'framer-motion'
import { NinxlEnterpriseHeroScene } from './ninxl-enterprise-graphics'

/** Parallax enterprise hero backdrop: matches landing hero motion */
export const NinxlEnterpriseHeroBackground = memo(function NinxlEnterpriseHeroBackground() {
  const shouldReduce = useReducedMotion()
  const { scrollYProgress } = useScroll()
  const sceneY = useTransform(scrollYProgress, [0, 0.35], [0, -60])
  const sceneOpacity = useTransform(scrollYProgress, [0, 0.3, 0.55], [1, 0.7, 0.15])

  return (
    <div className="ninxl-hero-bg pointer-events-none fixed inset-0 -z-10 overflow-hidden" aria-hidden>
      <div className="ninxl-theme-atmosphere-bg absolute inset-0" />

      <motion.div
        className="absolute inset-x-0 top-0 h-[72vh] min-h-[520px]"
        style={{
          y: shouldReduce ? 0 : sceneY,
          opacity: shouldReduce ? 1 : sceneOpacity,
        }}
      >
        <div className="absolute inset-0 ninxl-enterprise-grid opacity-40" />
        <div className="absolute inset-x-0 top-[12%] mx-auto max-w-5xl px-6">
          <NinxlEnterpriseHeroScene className="opacity-80" />
        </div>
        <div className="ninxl-hero-bg-fade absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-[color:var(--ninxl-theme-atmosphere)]" />
      </motion.div>

      <div className="ninxl-crt-overlay absolute inset-0 opacity-40" />
    </div>
  )
})